import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import {Tabs, Tab, Panel} from 'react-bootstrap';
import PersonalInfo from "./employeePersonalInfo";
import ContactInfo from "./employeeContactInfo";
import InfoHeader from "./profileHeader";
import {
  Segment,
  Divider,
  Breadcrumb,
  Dimmer,
  Loader
} from "semantic-ui-react";
import * as employeeActions from "../employeeActions";
import EmployeeEducation from "./EmployeeProfileSections/employeeEducation";
import EmployeeFamily from "./EmployeeProfileSections/employeeFamily";
import EmployeeSkills from "./EmployeeProfileSections/employeeSkills";
import EmployeeWorkHistory from "./EmployeeProfileSections/employeeWorkHistory";
import EmployeeOtherInfo from "./EmployeeProfileSections/employeeOtherInfo";
import {
  GetCompAndOffice,
  clearLocalStorageItem
} from "../../../Global/CustomFunctions";
class employeeDetailView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey: 1
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.editViewRedirect = this.editViewRedirect.bind(this);
    this.employeeViewredirect = this.employeeViewredirect.bind(this);
  }
  handleSelect(key) {
    this.setState({ activeTabKey: key });
  }
  componentWillMount() {
    clearLocalStorageItem("isEditView");
    this.props.actions.getEmployeeDetails(this.props.match.params.id);
  }
  editViewRedirect() {
    this.props.actions.clearEmployeeDetails();
    this.props.actions.editEmployeeDetails(true);
    localStorage.setItem("isEditView", true);
    let link = GetCompAndOffice();
    this.props.history.push(
      `${link}/dashboard/employee/edit/${this.props.match.params.id}`
    );
  }
  employeeViewredirect() {
    this.props.history.goBack();
  }
  render() {
    const {
      personalInfo,
      contactInfo,
      educationArray,
      familyArray,
      skillArray,
      otherInfo,
      workHistoryArray
    } = this.props;
    return (
      <div>
        <h1 className="mb15">Employees</h1>
        <div className="employee-list">
          <div className="empPicDetail">
            <Dimmer.Dimmable dimmed={this.props.Loading}>
              <Dimmer active={this.props.Loading} inverted={true}>
                <Loader>Loading</Loader>
              </Dimmer>
              <Segment className="mb20">
                <Breadcrumb>
                  <Breadcrumb.Section onClick={this.employeeViewredirect}>
                    Employees
                  </Breadcrumb.Section>
                  <Breadcrumb.Divider>/</Breadcrumb.Divider>
                  <Breadcrumb.Section active>
                    Employee Details
                  </Breadcrumb.Section>
                </Breadcrumb>
              </Segment>
              <div className="employee-profile-container clear">
                <div className="empDetailOuter">
                  <div className="empDetailLeftCnt">
                    <InfoHeader
                      InfoData={personalInfo}
                      onClickEdit={this.editViewRedirect}
                    />
                  </div>
                  <div className="empDetailRightCnt">
                    <div className="EmployeeAllDataCnt clear">
                      <div className="personalInfoCnt">
                        <PersonalInfo record={personalInfo} />
                      </div>
                      <div className="contactInfoCnt">
                        <ContactInfo record={contactInfo} />
                      </div>
                    </div>
                    <div className="fullWidth">
                      <Divider section />
                      <EmployeeEducation education={educationArray} />
                      <Divider section />
                      <EmployeeFamily family={familyArray} />
                      <Divider section />
                      <EmployeeSkills skills={skillArray} />
                      <Divider section />
                      <EmployeeWorkHistory works={workHistoryArray} />
                      <Divider section />
                      <div className="otherInfoCnt">
                        <EmployeeOtherInfo others={otherInfo} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Dimmer.Dimmable>
          </div>{" "}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ employeeReducer }) => {
  const {
    personalInfo,
    educationArray,
    familyArray,
    otherInfo,
    skillArray,
    empId,
    contactInfo,
    workHistoryArray,
    Loading
  } = employeeReducer;
  return {
    Loading,
    personalInfo,
    educationArray,
    familyArray,
    otherInfo,
    skillArray,
    empId,
    contactInfo,
    workHistoryArray
  };
};
const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(employeeActions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(employeeDetailView);

// export default employeeDetailView;
